import { render, staticRenderFns } from "./DevicePage.vue?vue&type=template&id=6b1c5912&scoped=true&"
import script from "./DevicePage.vue?vue&type=script&lang=js&"
export * from "./DevicePage.vue?vue&type=script&lang=js&"
import style0 from "./DevicePage.vue?vue&type=style&index=0&id=6b1c5912&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c5912",
  null
  
)

export default component.exports